/* AlivioActivo — interacciones propias. Vanilla, sin librerías. */
(function () {
  var aaCierraPedido = null;
  'use strict';

  /* Cada sección incluye este archivo, así que el navegador lo ejecuta una vez
     por sección. Sin este cerrojo, cada botón acaba con varios escuchadores y
     las acciones se cancelan entre sí (abrir + cerrar = no pasa nada). */
  if (window.__aaCargado) return;
  window.__aaCargado = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Animaciones de entrada al hacer scroll --- */
  function initReveals() {
    var items = document.querySelectorAll('.aa-reveal');
    if (!items.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('aa-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('aa-visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    items.forEach(function (el) { obs.observe(el); });
  }

  /* --- Preguntas frecuentes (acordeón) --- */
  function initFaq() {
    var items = document.querySelectorAll('.aa-faq__item');
    if (!items.length) return;
    items.forEach(function (item) {
      var q = item.querySelector('.aa-faq__q');
      var a = item.querySelector('.aa-faq__a');
      if (!q || !a) return;
      q.addEventListener('click', function () {
        var abierto = item.classList.contains('aa-open');
        var padre = item.parentNode;
        // cerrar los demás del mismo bloque
        padre.querySelectorAll('.aa-faq__item.aa-open').forEach(function (o) {
          if (o !== item) {
            o.classList.remove('aa-open');
            var oa = o.querySelector('.aa-faq__a');
            if (oa) oa.style.maxHeight = null;
            var oq = o.querySelector('.aa-faq__q');
            if (oq) oq.setAttribute('aria-expanded', 'false');
          }
        });
        if (abierto) {
          item.classList.remove('aa-open');
          a.style.maxHeight = null;
          q.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('aa-open');
          a.style.maxHeight = a.scrollHeight + 'px';
          q.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* --- Galería de la página de producto: carrusel que se corre al lado --- */
  function initGaleria() {
    var galeria = document.querySelector('[data-aa-galeria]');
    if (!galeria) return;

    var carr = galeria.querySelector('[data-aa-carr]');
    var minis = galeria.querySelectorAll('[data-aa-mini]');

    /* Modo antiguo: una sola foto que se cambiaba al tocar la miniatura.
       Se mantiene por si alguna plantilla todavía lo usa. */
    if (!carr) {
      var principal = galeria.querySelector('[data-aa-principal]');
      if (!principal || !minis.length) return;
      minis.forEach(function (b) {
        b.addEventListener('click', function () {
          var full = b.getAttribute('data-full');
          if (full) principal.setAttribute('src', full);
          principal.setAttribute('alt', b.getAttribute('data-alt') || '');
          minis.forEach(function (o) { o.classList.remove('aa-active'); });
          b.classList.add('aa-active');
        });
      });
      return;
    }

    var slides = carr.querySelectorAll('[data-aa-slide]');
    if (!slides.length) return;
    var puntos = galeria.querySelectorAll('[data-aa-carr-puntos] span');
    var prev = galeria.querySelector('[data-aa-carr-prev]');
    var next = galeria.querySelector('[data-aa-carr-next]');

    function actual() {
      /* Redondea por el ancho de una foto: es más fiable que escuchar
         el final del scroll, que en iOS llega tarde. */
      return Math.round(carr.scrollLeft / carr.clientWidth);
    }

    function irA(i) {
      var max = slides.length - 1;
      if (i < 0) i = 0;
      if (i > max) i = max;
      carr.scrollTo({ left: i * carr.clientWidth, behavior: 'smooth' });
    }

    function marcar() {
      var i = actual();
      minis.forEach(function (m, n) { m.classList.toggle('aa-active', n === i); });
      puntos.forEach(function (p, n) { p.classList.toggle('aa-on', n === i); });
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= slides.length - 1;
    }

    if (prev) prev.addEventListener('click', function () { irA(actual() - 1); });
    if (next) next.addEventListener('click', function () { irA(actual() + 1); });

    minis.forEach(function (b, n) {
      b.addEventListener('click', function () { irA(n); });
    });

    carr.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); irA(actual() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); irA(actual() - 1); }
    });

    var tic;
    carr.addEventListener('scroll', function () {
      clearTimeout(tic);
      tic = setTimeout(marcar, 60);
    }, { passive: true });

    window.addEventListener('resize', function () { clearTimeout(tic); tic = setTimeout(marcar, 120); });
    marcar();
  }

  /* --- Volver atrás --- */
  function initVolver() {
    var a = document.querySelector('[data-aa-volver]');
    if (!a) return;
    /* Si el cliente llegó desde otra página de la tienda, "volver" es volver
       de verdad: así conserva el scroll y el filtro donde estaba. Si llegó
       de un anuncio o de Google, el enlace lleva al catálogo. */
    a.addEventListener('click', function (e) {
      var mismo = document.referrer && document.referrer.indexOf(location.origin) === 0;
      if (mismo && history.length > 1) {
        e.preventDefault();
        history.back();
      }
    });
  }

  /* --- Agregar al carrito (sin salir de la página) --- */
  function initCarrito() {
    var caja = document.querySelector('[data-aa-producto]');
    if (!caja) return;
    var boton = caja.querySelector('[data-aa-carrito]');
    var aviso = caja.querySelector('[data-aa-carrito-aviso]');
    if (!boton) return;
    var texto = boton.querySelector('span');
    var original = texto ? texto.textContent : '';

    function decir(msg, mal) {
      if (!aviso) return;
      aviso.innerHTML = msg;
      aviso.hidden = false;
      aviso.classList.toggle('aa-mal', !!mal);
    }

    boton.addEventListener('click', function () {
      var campo = caja.querySelector('[data-aa-id]');
      var id = campo && campo.value;
      if (!id) return;
      boton.disabled = true;
      if (texto) texto.textContent = 'Agregando...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.d && res.d.description || 'No se pudo agregar');
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (carro) {
          var n = carro.item_count;
          decir('Agregado. Llevas ' + n + (n === 1 ? ' producto' : ' productos') +
                ' · <a href="/cart">Ver el carrito</a>');
          var burbuja = document.querySelector('.cart-count-bubble span:first-child, .cart-count-bubble');
          if (burbuja) burbuja.textContent = n;
        })
        .catch(function (err) {
          decir(err.message || 'No se pudo agregar. Intenta de nuevo.', true);
        })
        .then(function () {
          boton.disabled = false;
          if (texto) texto.textContent = original;
        });
    });
  }

  /* --- Selector de variantes (packs) en la página de producto --- */
  function initVariantes() {
    var caja = document.querySelector('[data-aa-producto]');
    if (!caja) return;
    var datos = caja.querySelector('[data-aa-variantes-json]');
    var botones = caja.querySelectorAll('[data-aa-variante]');
    var inputId = caja.querySelector('[data-aa-id]');
    var elNow = caja.querySelector('[data-aa-now]');
    var elWas = caja.querySelector('[data-aa-was]');
    var elOff = caja.querySelector('[data-aa-off]');
    var btnAdd = caja.querySelector('[data-aa-add]');
    if (!datos || !botones.length || !inputId) return;

    var variantes;
    try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
    if (!variantes || !variantes.length) return;

    var textoAdd = btnAdd ? btnAdd.getAttribute('data-texto') : '';
    var textoAgotado = btnAdd ? btnAdd.getAttribute('data-agotado') : 'Agotado';

    function pinta(v) {
      inputId.value = v.id;
      if (elNow) elNow.textContent = v.precio;
      if (elWas) {
        if (v.antes) { elWas.textContent = v.antes; elWas.hidden = false; }
        else { elWas.hidden = true; }
      }
      if (elOff) {
        if (v.off) { elOff.textContent = '-' + v.off + '%'; elOff.hidden = false; }
        else { elOff.hidden = true; }
      }
      if (btnAdd) {
        btnAdd.disabled = !v.disponible;
        btnAdd.textContent = v.disponible ? textoAdd : textoAgotado;
      }
    }

    botones.forEach(function (b) {
      b.addEventListener('click', function () {
        var id = b.getAttribute('data-aa-variante');
        var v = variantes.filter(function (x) { return String(x.id) === String(id); })[0];
        if (!v) return;
        botones.forEach(function (o) { o.classList.remove('aa-active'); });
        b.classList.add('aa-active');
        pinta(v);
      });
    });

    // estado inicial: la primera disponible, o la primera
    var inicial = variantes.filter(function (v) { return v.disponible; })[0] || variantes[0];
    var btnInicial = caja.querySelector('[data-aa-variante="' + inicial.id + '"]');
    if (btnInicial) btnInicial.classList.add('aa-active');
    pinta(inicial);
  }

  /* --- Buscador de seguimiento del pedido --- */
  function initSeguimiento() {
    var caja = document.querySelector('[data-aa-seguimiento]');
    if (!caja) return;
    var input = caja.querySelector('[data-aa-seg-input]');
    var btn = caja.querySelector('[data-aa-seg-btn]');
    var error = caja.querySelector('[data-aa-seg-error]');
    if (!input || !btn) return;

    var patron = caja.getAttribute('data-url') || 'https://www.17track.net/es/track?nums={numero}';

    function rastrear() {
      var numero = (input.value || '').trim();
      if (!numero) {
        if (error) error.classList.add('aa-visible');
        input.focus();
        return;
      }
      if (error) error.classList.remove('aa-visible');
      var destino = patron.replace('{numero}', encodeURIComponent(numero));
      window.open(destino, '_blank', 'noopener');
    }

    btn.addEventListener('click', rastrear);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); rastrear(); }
    });
    input.addEventListener('input', function () {
      if (error) error.classList.remove('aa-visible');
    });
  }

  /* --- Botón flotante de asesoría --- */
  function initAsesoria() {
    var caja = document.querySelector('[data-aa-asesoria]');
    if (!caja) return;
    var btn = caja.querySelector('[data-aa-ases-btn]');
    var panel = caja.querySelector('[data-aa-ases-panel]');
    if (!btn || !panel) return;

    function abrir() {
      caja.classList.add('aa-abierto');
      btn.setAttribute('aria-expanded', 'true');
    }
    function cerrar() {
      caja.classList.remove('aa-abierto');
      btn.setAttribute('aria-expanded', 'false');
    }

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (caja.classList.contains('aa-abierto')) { cerrar(); } else { abrir(); }
    });

    // cerrar al pulsar fuera
    document.addEventListener('click', function (e) {
      if (!caja.classList.contains('aa-abierto')) return;
      if (!caja.contains(e.target)) cerrar();
    });

    // cerrar con la tecla Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && caja.classList.contains('aa-abierto')) {
        cerrar();
        btn.focus();
      }
    });

    // al elegir una opción, cerrar el panel
    panel.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { cerrar(); });
    });

    /* --- cambio entre la lista de opciones y el formulario de llamada --- */
    var vistaMenu = panel.querySelector('[data-aa-vista="menu"]');
    var vistaLlamada = panel.querySelector('[data-aa-vista="llamada"]');
    var btnPedir = panel.querySelector('[data-aa-ases-pedir]');
    var btnVolver = panel.querySelector('[data-aa-ases-volver]');

    function verVista(cual) {
      if (!vistaMenu || !vistaLlamada) return;
      var esLlamada = cual === 'llamada';
      vistaMenu.hidden = esLlamada;
      vistaLlamada.hidden = !esLlamada;
      if (btnVolver) btnVolver.hidden = !esLlamada;
      if (esLlamada) {
        var primero = vistaLlamada.querySelector('input');
        if (primero) { try { primero.focus({ preventScroll: true }); } catch (e) {} }
      }
    }

    if (btnPedir) btnPedir.addEventListener('click', function () { verVista('llamada'); });
    if (btnVolver) btnVolver.addEventListener('click', function () { verVista('menu'); });

    // si el formulario se acaba de enviar, abrir directamente esa vista
    if (caja.hasAttribute('data-aa-ases-enviado')) {
      verVista('llamada');
      abrir();
    }

    // al cerrar, volver siempre a la lista de opciones
    var cerrarOriginal = cerrar;
    cerrar = function () {
      cerrarOriginal();
      if (!caja.hasAttribute('data-aa-ases-enviado')) {
        setTimeout(function () { verVista('menu'); }, 320);
      }
    };
  }

  /* --- Barra de compra fija: aparece al pasar el botón principal --- */
  function initBarra() {
    var barra = document.querySelector('[data-aa-barra]');
    var caja = document.querySelector('[data-aa-producto]');
    if (!barra || !caja) return;

    var addPrincipal = caja.querySelector('[data-aa-add]');
    var sel = barra.querySelector('[data-aa-barra-select]');
    var idBarra = barra.querySelector('[data-aa-barra-id]');
    var nowBarra = barra.querySelector('[data-aa-barra-now]');
    var wasBarra = barra.querySelector('[data-aa-barra-was]');
    var addBarra = barra.querySelector('[data-aa-barra-add]');
    var idPrincipal = caja.querySelector('[data-aa-id]');
    var botones = caja.querySelectorAll('[data-aa-variante]');

    var variantes = [];
    var datos = caja.querySelector('[data-aa-variantes-json]');
    if (datos) { try { variantes = JSON.parse(datos.textContent); } catch (e) {} }

    function pintaBarra(id) {
      var v = variantes.filter(function (x) { return String(x.id) === String(id); })[0];
      if (!v) return;
      if (idBarra) idBarra.value = v.id;
      if (nowBarra) nowBarra.textContent = v.precio;
      if (wasBarra) {
        if (v.antes) { wasBarra.textContent = v.antes; wasBarra.hidden = false; }
        else { wasBarra.hidden = true; }
      }
      if (addBarra) addBarra.disabled = !v.disponible;
      if (sel && String(sel.value) !== String(v.id)) sel.value = v.id;
    }

    // la barra sigue al selector principal
    botones.forEach(function (b) {
      b.addEventListener('click', function () {
        pintaBarra(b.getAttribute('data-aa-variante'));
      });
    });

    // y el selector principal sigue a la barra
    if (sel) {
      sel.addEventListener('change', function () {
        var id = sel.value;
        if (idPrincipal) idPrincipal.value = id;
        var bp = caja.querySelector('[data-aa-variante="' + id + '"]');
        if (bp) bp.click();
        pintaBarra(id);
      });
    }

    // estado inicial
    if (idPrincipal) pintaBarra(idPrincipal.value);

    // mostrar solo cuando el botón principal ya no se ve
    function alterna(mostrar) {
      barra.classList.toggle('aa-visible', mostrar);
      document.body.classList.toggle('aa-con-barra', mostrar);
      // apartamos el botón flotante justo la altura real de la barra
      var alto = mostrar ? barra.offsetHeight : 0;
      document.documentElement.style.setProperty('--aa-barra-alto', alto + 'px');
    }
    window.addEventListener('resize', function () {
      if (document.body.classList.contains('aa-con-barra')) {
        document.documentElement.style.setProperty('--aa-barra-alto', barra.offsetHeight + 'px');
      }
    });
    if (!addPrincipal || !('IntersectionObserver' in window)) { alterna(true); return; }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { alterna(!e.isIntersecting); });
    }, { rootMargin: '0px 0px -40px 0px' });
    obs.observe(addPrincipal);
  }

  /* --- Pedido directo: vacía el carrito, añade el pack elegido y va al formulario --- */

  /* --- Carruseles de producto (puede haber varios en la misma página) --- */

  /* ------------------------------------------------------------------
     FORMULARIO DE PEDIDO -> WHATSAPP
     El cliente rellena sus datos y se abre WhatsApp con el pedido ya
     escrito, para cerrarlo por chat. No pasa por el checkout.
     ------------------------------------------------------------------ */
  /* ============================================================
     PEDIDO POR WHATSAPP
     El formulario es un formulario de contacto de Shopify y viaja a
     un marco escondido: el pedido queda guardado y le llega por correo
     a la tienda AUNQUE el cliente nunca mande el WhatsApp. Después
     llevamos al cliente a WhatsApp con el pedido ya escrito.
     ============================================================ */
  function initPedidoDatos() {
    var forms = document.querySelectorAll('[data-aa-form-datos]');
    if (!forms.length) return;

    forms.forEach(function (form) {
      var numero = form.getAttribute('data-aa-ped-wa');
      if (!numero) return;
      var producto = form.getAttribute('data-aa-ped-producto') || '';
      var sel = form.querySelector('[data-aa-ped-variante]');
      var cuerpo = form.querySelector('[data-aa-ped-cuerpo]');
      var permiso = form.querySelector('[data-aa-ped-permiso]');
      var ofertaPrecio = form.querySelector('[data-aa-down-precio-aplicado]');
      var marco = document.querySelector('iframe[name="aa-ped-marco"]');
      var yaFue = false;

      function texto(nombre) {
        var el = form.querySelector('[data-aa-ped="' + nombre + '"]');
        if (!el) return '';
        // en los desplegables interesa lo que LEE el cliente, no el código
        if (el.tagName === 'SELECT') {
          var op = el.options[el.selectedIndex];
          return op && op.value ? op.text.trim() : '';
        }
        return el.value.trim();
      }
      function pack() {
        if (!sel) return '';
        var op = sel.options[sel.selectedIndex];
        return op ? op.text.trim() : '';
      }
      function lineas() {
        return [
          'Hola! Quiero hacer un pedido:',
          '',
          'Producto: ' + producto,
          (ofertaPrecio && ofertaPrecio.value) ? 'Cantidad: 1 unidad' : (pack() ? 'Cantidad: ' + pack() : ''),
          ofertaPrecio && ofertaPrecio.value
            ? 'Precio especial de este pedido: $' + new Intl.NumberFormat('es-CL', { maximumFractionDigits: 0 }).format(Number(ofertaPrecio.value)) + ' (precio normal ' + (form.getAttribute('data-aa-ped-precio-normal') || '') + ')'
            : '',
          '',
          'Nombre: '    + texto('nombre'),
          'Teléfono: '  + texto('telefono'),
          'Correo: '    + texto('correo'),
          'Dirección: ' + texto('direccion'),
          'Comuna: '    + texto('comuna'),
          texto('region') ? 'Región: ' + texto('region') : '',
          texto('nota')   ? 'Nota: '   + texto('nota')   : '',
          '',
          'Pago contra entrega. Envío gratis.'
        ].filter(function (l) { return l !== ''; });
      }

      function aWhatsapp() {
        if (yaFue) return;
        yaFue = true;
        window.location.href = 'https://wa.me/' + numero +
          '?text=' + encodeURIComponent(lineas().join('\n'));
      }

      form.addEventListener('submit', function () {
        // El navegador ya comprobó los campos obligatorios antes de llegar aquí.

        // 1) armamos el correo que le llega a la tienda con TODO el pedido
        if (cuerpo) {
          var extra = lineas().slice(2);
          if (permiso) {
            extra.push('');
            extra.push('Permiso para ofertas: ' + (permiso.checked ? 'SÍ' : 'no'));
          }
          cuerpo.value = extra.join('\n');
        }

        var boton = form.querySelector('.aa-ped__enviar');
        if (boton) { boton.disabled = true; boton.textContent = 'Abriendo WhatsApp...'; }

        /* Avisamos a Shopify de que hubo un pedido por WhatsApp. El píxel
           personalizado lo recoge y se lo manda a Meta como "Lead", para
           poder ver el costo por pedido y que las campañas optimicen. */
        try {
          if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
            Shopify.analytics.publish('pedido_whatsapp', {
              producto: producto,
              pack: pack(),
              comuna: texto('comuna'),
              region: texto('region'),
              precioOferta: ofertaPrecio && ofertaPrecio.value ? Number(ofertaPrecio.value) : null,
              ofertaDownsell: !!(ofertaPrecio && ofertaPrecio.value)
            });
          }
        } catch (err) { /* nunca bloquear el pedido por esto */ }

        // 2) NO cortamos el envío: el formulario viaja al marco escondido.
        //    En cuanto Shopify responde, mandamos al cliente a WhatsApp.
        if (marco) marco.addEventListener('load', aWhatsapp, { once: true });
        // y si Shopify tarda o falla, igual lo mandamos: nunca se pierde la venta
        setTimeout(aWhatsapp, 2500);
      });
    });
  }

  function initCarruseles() {
    var carruseles = document.querySelectorAll('[data-aa-carrusel]');
    if (!carruseles.length) return;

    carruseles.forEach(function (car) {
      var pista = car.querySelector('[data-aa-car-pista]');
      var prev = car.querySelector('[data-aa-car-prev]');
      var next = car.querySelector('[data-aa-car-next]');
      if (!pista) return;

      function paso() {
        var item = pista.querySelector('.aa-car__item');
        if (!item) return pista.clientWidth * 0.8;
        var estilo = window.getComputedStyle(pista);
        var hueco = parseFloat(estilo.columnGap || estilo.gap) || 0;
        var ancho = item.getBoundingClientRect().width + hueco;
        // cuántas tarjetas ENTERAS caben (el último hueco no ocupa sitio)
        var caben = Math.max(1, Math.floor((pista.clientWidth + hueco) / ancho));
        var salto = ancho * caben;
        // nunca pasarse del final
        var restante = pista.scrollWidth - pista.clientWidth - pista.scrollLeft;
        return Math.min(salto, Math.max(restante, ancho));
      }

      function actualizaFlechas() {
        var max = pista.scrollWidth - pista.clientWidth - 2;
        if (prev) prev.disabled = pista.scrollLeft <= 2;
        if (next) next.disabled = pista.scrollLeft >= max;
      }

      if (prev) prev.addEventListener('click', function () { pista.scrollBy({ left: -paso(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { pista.scrollBy({ left: paso(), behavior: 'smooth' }); });

      pista.addEventListener('scroll', actualizaFlechas, { passive: true });
      window.addEventListener('resize', actualizaFlechas);
      actualizaFlechas();

      // arrastrar con el ratón en ordenador
      var arrastrando = false, inicioX = 0, inicioScroll = 0, movido = false;
      pista.addEventListener('mousedown', function (e) {
        arrastrando = true; movido = false;
        inicioX = e.pageX; inicioScroll = pista.scrollLeft;
        pista.style.scrollBehavior = 'auto';
      });
      window.addEventListener('mousemove', function (e) {
        if (!arrastrando) return;
        var d = e.pageX - inicioX;
        if (Math.abs(d) > 4) movido = true;
        pista.scrollLeft = inicioScroll - d;
      });
      window.addEventListener('mouseup', function () {
        if (!arrastrando) return;
        arrastrando = false;
        pista.style.scrollBehavior = 'smooth';
        actualizaFlechas();
      });
      // que arrastrar no abra el producto sin querer
      pista.addEventListener('click', function (e) {
        if (movido) { e.preventDefault(); e.stopPropagation(); movido = false; }
      }, true);
    });
  }

  /* ============================================================
     ABRIR EL FORMULARIO DE WHATSAPP
     El botón "Pedir ahora" ya no manda al carrito de Shopify:
     abre la ventana con los datos del cliente. Si por lo que sea
     la ventana no existe, baja hasta el formulario de la página.
     ============================================================ */
  function initAbrirPedido() {
    var disparadores = document.querySelectorAll('[data-aa-abrir-pedido]');
    if (!disparadores.length) return;

    var ventana = document.querySelector('[data-aa-pedido-ventana]');
    var seccion = document.querySelector('#pedido');
    var ultimoFoco = null;

    function variantePuesta() {
      var sel = ventana ? ventana.querySelector('[data-aa-ped-variante]') : null;
      if (!sel) return;
      var campo = document.querySelector('[data-aa-id]') || document.querySelector('[data-aa-barra-id]');
      if (!campo || !campo.value) return;
      var hay = sel.querySelector('option[value="' + campo.value + '"]');
      if (hay && !hay.disabled) sel.value = campo.value;
    }

    function abrir(e) {
      if (e) e.preventDefault();
      if (!ventana) {
        if (seccion) {
          seccion.scrollIntoView({ behavior: 'smooth', block: 'center' });
          var primero = seccion.querySelector('[data-aa-ped="nombre"]');
          if (primero) setTimeout(function () { primero.focus(); }, 500);
        }
        return;
      }
      ultimoFoco = document.activeElement;
      variantePuesta();
      ventana.classList.add('aa-abierto');
      document.body.classList.add('aa-ped-bloqueado');
      var campo = ventana.querySelector('[data-aa-ped="nombre"]');
      if (campo) setTimeout(function () { campo.focus(); }, 60);
    }

    function cerrar(forzar) {
      if (!ventana) return;
      if (!forzar && typeof aaInterceptaCierre === 'function' && aaInterceptaCierre()) return;
      ventana.classList.remove('aa-abierto');
      document.body.classList.remove('aa-ped-bloqueado');
      if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus();
    }

    disparadores.forEach(function (b) { b.addEventListener('click', abrir); });
    aaCierraPedido = function () { cerrar(true); };

    if (ventana) {
      ventana.querySelectorAll('[data-aa-cerrar-pedido]').forEach(function (x) {
        // sin pasar el evento: cerrar(evento) lo tomaría como "forzar"
        x.addEventListener('click', function () { cerrar(); });
      });
      document.addEventListener('keydown', function (ev) {
        if (ev.key === 'Escape' && ventana.classList.contains('aa-abierto')) cerrar();
      });
    }

    // los enlaces internos que apuntaban al formulario también la abren
    document.querySelectorAll('a[href="#pedido"], a[href="#comprar"]').forEach(function (a) {
      a.addEventListener('click', abrir);
    });
  }

  /* ============================================================
     OFERTAS DEL FORMULARIO
     Arriba (upsell): ofrece el pack siguiente, con el ahorro REAL
     calculado contra el precio de la unidad suelta.
     Abajo (downsell): si cierra llevando más de uno, le ofrece una
     sola unidad antes de irse. Una vez por visita, y el botón de
     cerrar sigue cerrando.
     ============================================================ */
  var aaInterceptaCierre = null;

  function initPedidoOfertas() {
    var form = document.querySelector('[data-aa-form-datos]');
    if (!form) return;
    var sel = form.querySelector('[data-aa-ped-variante]');
    var datos = form.querySelector('[data-aa-ped-variantes]');
    if (!datos) return;

    var variantes;
    try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
    if (!variantes || !variantes.length) return;

    var uno = variantes.filter(function (v) { return v.cantidad === 1; })[0] || variantes[0];

    /* ---------- upsell ---------- */
    var bump = form.querySelector('[data-aa-ped-bump]');
    var bTit = form.querySelector('[data-aa-bump-titulo]');
    var bTxt = form.querySelector('[data-aa-bump-texto]');
    var bBtn = form.querySelector('[data-aa-bump-si]');
    var destino = null;

    function rellena(txt, v) {
      return String(txt || '')
        .replace(/\{pack\}/g, v.titulo)
        .replace(/\{ahorro\}/g, v.ahorroTexto)
        .replace(/\{unitario\}/g, v.unitarioTexto)
        .replace(/\{sueltoUnitario\}/g, uno.precioTexto)
        .replace(/\{precioUno\}/g, uno.precioTexto)
        .replace(/\{precioNormal\}/g, uno.precioTexto)
        .replace(/\{precioDown\}/g, '$' + new Intl.NumberFormat('es-CL', { maximumFractionDigits: 0 }).format(downPrecio))
        .replace(/\{precio\}/g, v.precioTexto);
    }

    function actual() {
      if (!sel) return uno;
      return variantes.filter(function (v) { return String(v.id) === String(sel.value); })[0];
    }

    function pintaBump() {
      if (!bump || !bBtn || !sel) return;
      var hoy = actual();
      if (!hoy) { bump.hidden = true; return; }
      // el siguiente pack disponible que de verdad salga mejor por unidad
      destino = variantes.filter(function (v) {
        return v.disponible && v.cantidad > hoy.cantidad && v.ahorro > hoy.ahorro;
      }).sort(function (a, b) { return a.cantidad - b.cantidad; })[0];

      if (!destino) { bump.hidden = true; return; }
      if (bTit) bTit.textContent = rellena(bump.getAttribute('data-titulo'), destino);
      if (bTxt) bTxt.textContent = rellena(bump.getAttribute('data-texto'), destino);
      bBtn.textContent = rellena(bump.getAttribute('data-boton'), destino);
      bump.hidden = false;
    }

    if (bBtn) {
      bBtn.addEventListener('click', function () {
        if (!destino) return;
        sel.value = destino.id;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        bump.classList.add('aa-ok');
        setTimeout(function () { bump.classList.remove('aa-ok'); }, 900);
      });
    }
    if (sel) {
      sel.addEventListener('change', pintaBump);
      pintaBump();
    }

    /* ---------- downsell ---------- */
    var panel = document.querySelector('[data-aa-ped-retener]');
    if (!panel) return;
    var dSi = panel.querySelector('[data-aa-down-si]');
    var dNo = panel.querySelector('[data-aa-down-no]');
    var dTxt = panel.querySelector('[data-aa-down-texto]');
    var dAplicado = form.querySelector('[data-aa-down-aplicado]');
    var campoPrecioOferta = form.querySelector('[data-aa-down-precio-aplicado]');
    var etiquetaVariante = form.querySelector('label[for="aa-ped-var"]');
    var downPrecio = parseInt(panel.getAttribute('data-aa-down-precio'), 10) || 16990;
    var claveVisita = 'aa-downsell-v2:' + window.location.pathname;
    var yaSeMostro = false;
    var yaPidio = false;
    try { yaSeMostro = sessionStorage.getItem(claveVisita) === '1'; } catch (e) {}

    form.addEventListener('submit', function () { yaPidio = true; });

    aaInterceptaCierre = function () {
      if (yaSeMostro || yaPidio) return false;
      var hoy = actual();
      if (!hoy) return false;
      yaSeMostro = true;
      try { sessionStorage.setItem(claveVisita, '1'); } catch (e) {}
      panel.hidden = false;
      if (dTxt) {
        try { dTxt.textContent = rellena(dTxt.getAttribute('data-plantilla') || dTxt.textContent, hoy); } catch (e) {}
      }
      return true;   // lo manejamos nosotros: no cierres todavía
    };

    if (dSi) dSi.addEventListener('click', function () {
      if (sel) {
        sel.value = uno.id;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        sel.disabled = true;
      }
      if (bump) bump.hidden = true;
      if (etiquetaVariante) etiquetaVariante.hidden = true;
      if (sel) sel.hidden = true;
      if (campoPrecioOferta) campoPrecioOferta.value = String(downPrecio);
      if (dAplicado) {
        dAplicado.textContent = 'Precio especial aplicado a este pedido: $' + new Intl.NumberFormat('es-CL', { maximumFractionDigits: 0 }).format(downPrecio) + '. Una unidad, envío gratis y pago al recibir.';
        dAplicado.hidden = false;
      }
      panel.hidden = true;
      var campo = form.querySelector('[data-aa-ped="nombre"]');
      if (campo) campo.focus();
    });
    if (dNo) dNo.addEventListener('click', function () {
      panel.hidden = true;
      if (typeof aaCierraPedido === 'function') aaCierraPedido();
    });
  }

  /* ---------- Urgencia real: corte de despacho y fin del precio de lanzamiento ----------
     Todo se calcula en hora de Santiago con Intl, así que el horario de verano
     chileno no lo descuadra. Nada reinicia al recargar: el corte es una hora del
     día de verdad y la fecha de lanzamiento es una fecha de verdad. */

  var AA_DIAS_ES = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  var aaFmtCL = null;
  var aaFmtFecha = null;

  function aaRelojCL() {
    if (!aaFmtCL) {
      aaFmtCL = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Santiago', hour12: false,
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit'
      });
    }
    return aaFmtCL;
  }

  function aaPartesCL(fecha) {
    var o = {};
    aaRelojCL().formatToParts(fecha).forEach(function (x) { o[x.type] = x.value; });
    if (o.hour === '24') o.hour = '00';
    return { y: +o.year, m: +o.month, d: +o.day, h: +o.hour, mi: +o.minute, s: +o.second };
  }

  /* Instante (ms) en que el reloj de Chile marca y-m-d h:mi */
  function aaInstanteCL(y, m, d, h, mi) {
    var pared = Date.UTC(y, m - 1, d, h, mi, 0);
    var t = pared;
    for (var i = 0; i < 2; i++) {
      var o = aaPartesCL(new Date(t));
      var desfase = Date.UTC(o.y, o.m - 1, o.d, o.h, o.mi, o.s) - t;
      t = pared - desfase;
    }
    return t;
  }

  /* Próximo corte de despacho: salta fines de semana */
  function aaProximoCorte(hora, minuto, sabado) {
    var ahora = Date.now();
    var o = aaPartesCL(new Date(ahora));
    var y = o.y, m = o.m, d = o.d;
    for (var i = 0; i < 9; i++) {
      var t = aaInstanteCL(y, m, d, hora, minuto);
      var dow = new Date(Date.UTC(y, m - 1, d)).getUTCDay();
      var habil = (dow >= 1 && dow <= 5) || (sabado && dow === 6);
      if (habil && t > ahora) return { t: t, dow: dow, dias: i };
      var sig = new Date(Date.UTC(y, m - 1, d) + 86400000);
      y = sig.getUTCFullYear(); m = sig.getUTCMonth() + 1; d = sig.getUTCDate();
    }
    return null;
  }

  function aaEspera(ms) {
    var seg = Math.max(0, Math.floor(ms / 1000));
    var h = Math.floor(seg / 3600);
    var min = Math.floor((seg % 3600) / 60);
    var s = seg % 60;
    if (h > 0) return min > 0 ? h + ' h ' + min + ' min' : h + ' h';
    if (min >= 10) return min + ' min';
    if (min > 0) return min + ' min ' + (s < 10 ? '0' : '') + s + ' s';
    return s + ' s';
  }

  /* Pinta el texto del comerciante reemplazando {tokens}; el valor va en negrita
     si así se pide. Se construye con nodos de texto: nada de innerHTML. */
  function aaPintarTokens(el, plantilla, mapa) {
    if (!el) return;
    el.textContent = '';
    (plantilla || '').split(/(\{[a-z]+\})/).forEach(function (p) {
      if (!p) return;
      if (Object.prototype.hasOwnProperty.call(mapa, p)) {
        if (mapa[p].fuerte) {
          var f = document.createElement('strong');
          f.textContent = mapa[p].v;
          el.appendChild(f);
        } else {
          el.appendChild(document.createTextNode(mapa[p].v));
        }
      } else {
        el.appendChild(document.createTextNode(p));
      }
    });
  }

  function initUrgencia() {
    var cortes = document.querySelectorAll('[data-aa-corte]');
    var lanzamientos = document.querySelectorAll('[data-aa-lanzamiento]');
    if (!cortes.length && !lanzamientos.length) return;
    if (!window.Intl || !Intl.DateTimeFormat || !Intl.DateTimeFormat.prototype.formatToParts) return;

    function pintarCorte(caja) {
      var hora = parseInt(caja.getAttribute('data-hora'), 10);
      var minuto = parseInt(caja.getAttribute('data-minuto'), 10) || 0;
      if (isNaN(hora)) return;
      var sabado = caja.getAttribute('data-sabado') === '1';
      var base = caja.querySelector('[data-aa-corte-base]');
      var hoy = caja.querySelector('[data-aa-corte-hoy]');
      var cerrado = caja.querySelector('[data-aa-corte-cerrado]');
      var p = aaProximoCorte(hora, minuto, sabado);
      if (!p) return;
      if (base) base.hidden = true;
      if (p.dias === 0) {
        if (cerrado) cerrado.hidden = true;
        aaPintarTokens(hoy, hoy && hoy.getAttribute('data-plantilla'), {
          '{tiempo}': { v: aaEspera(p.t - Date.now()), fuerte: true }
        });
        if (hoy) hoy.hidden = false;
      } else {
        if (hoy) hoy.hidden = true;
        var dia = p.dias === 1 ? 'mañana' : 'el ' + AA_DIAS_ES[p.dow];
        aaPintarTokens(cerrado, cerrado && cerrado.getAttribute('data-plantilla'), {
          '{dia}': { v: dia, fuerte: true }
        });
        if (cerrado) cerrado.hidden = false;
      }
    }

    function pintarLanzamiento(caja) {
      var trozos = (caja.getAttribute('data-fin') || '').split('-');
      if (trozos.length !== 3) { caja.hidden = true; return; }
      /* el precio vale hasta el final de ese día en Chile */
      var fin = aaInstanteCL(+trozos[0], +trozos[1], +trozos[2], 23, 59) + 60000;
      var ms = fin - Date.now();
      if (ms <= 0) { caja.hidden = true; return; }
      if (!aaFmtFecha) {
        aaFmtFecha = new Intl.DateTimeFormat('es-CL', {
          timeZone: 'America/Santiago', weekday: 'long', day: 'numeric', month: 'long'
        });
      }
      var dias = Math.ceil(ms / 86400000);
      var cuanto = dias > 1 ? dias + ' días' : aaEspera(ms);
      aaPintarTokens(caja.querySelector('[data-aa-lanz-txt]'),
        caja.querySelector('[data-aa-lanz-txt]').getAttribute('data-plantilla'), {
          '{fecha}': { v: aaFmtFecha.format(new Date(fin - 60000)), fuerte: false },
          '{dias}': { v: cuanto, fuerte: true }
        });
      caja.hidden = false;
    }

    function pintarTodo() {
      Array.prototype.forEach.call(cortes, pintarCorte);
      Array.prototype.forEach.call(lanzamientos, pintarLanzamiento);
    }

    pintarTodo();
    setInterval(pintarTodo, 1000);
  }

  /* ---------- Botones de compra de otros temas → pedido por WhatsApp ----------
     En los temas comprados el botón grande agrega al carrito y manda al pago con
     tarjeta. Aquí no hay pago con tarjeta: todo va por WhatsApp y se paga al
     recibir. Esto convierte esos botones en el botón de pedido, sin tocar el
     tema por dentro. Solo actúa si el tema trae esos botones. */
  function initCodBotones() {
    var principal = document.querySelectorAll('.shop-add-to-cart-button, .sticky-add-to-cart__button');
    if (!principal.length) return;
    if (!document.querySelector('[data-aa-pedido-ventana]')) return;

    /* espejo de la variante elegida, para que el pedido abra con el pack correcto */
    var formulario = document.querySelector('form[action*="/cart/add"]');
    if (formulario && !document.querySelector('[data-aa-id]')) {
      var espejo = document.createElement('input');
      espejo.type = 'hidden';
      espejo.setAttribute('data-aa-id', '');
      document.body.appendChild(espejo);
      var copia = function () {
        var campo = formulario.querySelector('[name="id"]');
        if (campo && campo.value) espejo.value = campo.value;
      };
      copia();
      document.addEventListener('change', copia, true);
      document.addEventListener('click', function () { setTimeout(copia, 50); }, true);
      formulario.addEventListener('submit', function (e) { e.preventDefault(); });
    }

    var todos = [];
    Array.prototype.push.apply(todos, principal);
    Array.prototype.push.apply(todos, document.querySelectorAll('a[href$="#pedido"]'));
    todos.forEach(function (b) {
      if (b.hasAttribute('data-aa-abrir-pedido')) return;
      b.setAttribute('data-aa-abrir-pedido', '');
      if (b.tagName === 'BUTTON') b.type = 'button';
    });
  }

  function init() {
    initCodBotones();
    initReveals();
    initFaq();
    initGaleria();
    initVolver();
    initCarrito();
    initVariantes();
    initSeguimiento();
    initAsesoria();
    initBarra();
    initAbrirPedido();
    initPedidoDatos();
    initPedidoOfertas();
    initCarruseles();
    initUrgencia();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
